import { RestaurantItemBasketCard } from "./RestaurantItemBasketCard";

export default RestaurantItemBasketCard;
